import {
  ChangeDetectionStrategy,
  Component,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { SearchState } from '@features/search/services/search.state';

@Component({
  selector: 'app-search-summary-card',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatMenuModule],
  templateUrl: './search-summary-card.component.html',
  styleUrl: './search-summary-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchSummaryCardComponent {
  readonly searchState = inject(SearchState);
}
